// extracted by mini-css-extract-plugin
module.exports = {"ListHeading":"styles_ListHeading__lZLKQ","ListHeadingContent":"styles_ListHeadingContent__1sz95","ListHeadingRight":"styles_ListHeadingRight__21LOW"};